import { IconX } from "@tabler/icons-react";
import { NavLink } from "react-router";

const OffCanvas = (props: any) => {
    return (
        <>
            <div className="offcanvas offcanvas-start w-75" id="mobile-canvas">
                <div className="container">
                    <div className="ّoffcanvas-header py-2 pb-0 align-items-center d-flex justify-content-between">
                        <NavLink className="nav-link text-black mx-1" to={'/'}>
                            <img src={require('./../../assets/media/logo/logo_new.png')} alt="logo" className="logo-img-new" />
                        </NavLink>
                        <IconX data-bs-dismiss="offcanvas" />
                    </div>
                    <hr />
                    <div className="offcanvas-body">
                        <ul className="list-group px-0 pt-0">
                            <li className="list-group-item px-0 pt-0">
                                <NavLink className="nav-link text-black mx-1" to={'/'}>
                                    خانه
                                </NavLink>
                            </li>
                            {props.routes.map((address: any) => (
                                <>
                                    {address.show ? (
                                        <>
                                            <li className="list-group-item px-0" key={address.address + 'address'}>
                                                <NavLink className="nav-link text-black mx-1" to={address.address}>
                                                    {address.label}
                                                </NavLink>
                                            </li>
                                        </>
                                    ) : null}
                                </>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OffCanvas;